// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rOeQy","newExpiryDate":"styles_newExpiryDate__1s1qs","footer":"styles_footer__1pTBA"};